import React, { useState, useRef } from 'react'
import ModalVideo from 'react-modal-video'
import style from './modal.mod.scss'
import { isBrowser } from '@context/themeContext'
import ReactDOM from 'react-dom'
import { Button } from '@components'
import { useAttachDatocmsFileVideo } from '../lib/datocms-video-playback'

const windowAvailable = isBrowser()

const appRoot = windowAvailable && window.document.querySelector('#___gatsby')

const EMBED_CHANNELS = new Set(['youtube', 'vimeo', 'youku'])

const isEmbedChannelVideo = video =>
  video &&
  EMBED_CHANNELS.has(String(video.provider || '').toLowerCase()) &&
  video.providerUid

const ModalFileFieldVideo = ({ video }) => {
  const ref = useRef(null)
  useAttachDatocmsFileVideo(ref, video)

  return (
    <video
      ref={ref}
      className={style.modalHtml5Video}
      controls
      playsInline
      autoPlay
    />
  )
}

const Modal = ({ video, buttonText, modifiers = [] }) => {
  const [isOpen, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const embed = isEmbedChannelVideo(video)

  return (
    <div className={[style.modal, ...modifiers].join(' ')}>
      <div className={style.modal__wrap}>
        {video &&
          windowAvailable &&
          ReactDOM.createPortal(
            embed ? (
              <ModalVideo
                isOpen={isOpen}
                channel={video.provider}
                videoId={video.providerUid}
                onClose={handleClose}
                autoplay
              />
            ) : (
              <ModalVideo
                isOpen={isOpen}
                channel="custom"
                url=""
                videoId=""
                onClose={handleClose}
                autoplay
              >
                <ModalFileFieldVideo video={video} />
              </ModalVideo>
            ),
            appRoot
          )}
        <Button
          aria-label={`Open modal and play video: ${video.title || 'Video'}`}
          onClick={handleOpen}
          color={'inverse'}
          alignment={'center'}
          children={buttonText}
          type={'button'}
          length={'large'}
        />
      </div>
    </div>
  )
}

export default Modal
